<template>
                        <div class="huas-card huas-ranking-card huas-card-bordered">
                          <div class="huas-card-head">
                            <div class="huas-card-head-wrapper">
                                <div class="huas-card-head-title">热门榜</div>
                            </div>
                          </div>
                          <div class="huas-card-body">
                            <div class="huas-table-wrapper">
                                <div class="huas-spin-nested-loading">
                                    <div class="huas-spin-container">
                                        <div class="huas-table huas-table-default huas-table-scroll-position-left">
                                            <div class="huas-table-content">
                                                <div class="huas-table-body">
<!--                                                     <el-table
                                                        :data="hot_strategiesList"
                                                        :cell-class-name="rowClass"
                                                        style="width: 100%">
                                                        <el-table-column
                                                            prop="RowNum"
                                                            label=""
                                                            width="39">
                                                     <template #scope="{row}">
                                                            <span v-if="row.RowNum == 1" data-rank='1' class="huas-ranking-card-rank_1">{{ row.RowNum+10 }}</span>
                                                            <span v-else-if="row.RowNum == 2" data-rank='2' class="huas-ranking-card-rank_2">{{ row.RowNum+20 }}</span>
                                                            <span v-else-if="row.RowNum == 3" data-rank='3' class="huas-ranking-card-rank_3">{{ row.RowNum+30 }}</span>
                                                            <span v-else=""  class="huas-ranking-card-rank_1">{{ row.RowNum+40 }}</span>
                                                        </template>    
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="name"
                                                            label="策略名称"
                                                            width="156">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="策略近1周收益率"
                                                            label="近1周收益"
                                                            width="98">
                                                        </el-table-column>
                                                        </el-table> -->
                                                        <Table :columns="hotstrategiesColumns" :data="hot_strategiesList" width="310">
                                                          <template #RowNum="{ row }" >
                                                            <div class="column_center">
                                                              <span
                                                                v-if="row.RowNum === 1"
                                                                class="huas-ranking-card-rank_1"
                                                                >{{ row.RowNum }}</span
                                                              >
                                                              <span
                                                                v-else-if="row.RowNum === 2"
                                                                class="huas-ranking-card-rank_2"
                                                                >{{ row.RowNum }}</span
                                                              >        
                                                              <span
                                                                v-else-if="row.RowNum === 3"
                                                                class="huas-ranking-card-rank_3"
                                                                >{{ row.RowNum }}</span
                                                              >                                                                                                                        
                                                              <span v-else class="huas-ranking-card-rank">{{ row.RowNum }}</span>
                                                            </div>
                                                          </template>  
                                                          <template #name="{ row }" >
                                                            <div class="column_center">
                                                              <router-link :to="{name:'strategydetailsview', query:{sid:row.sid,name:row.name, ben_name:row.ben_name}}" custom v-slot="{ navigate }">
                                                                  <div class="" @click="navigate" role="link">
                                                                    <span class="strategy-title">{{row.name}}  </span>
                                                                  </div>
                                                              </router-link>                                                     

                                                            </div>
                                                          </template>
                                                          <template #策略近1周收益率="{ row }" >
                                                            <div class="column_center">
                                                              <span v-if="row.策略近1周收益率>=0" class="demo-table-postive-column">{{row.策略近1周收益率}}  </span>
                                                              <span v-else="" class="demo-table-minus-column">{{row.策略近1周收益率}}  </span>

                                                            </div>
                                                          </template>
                                                                                                                                                                                        
                                                        </Table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="huas-card huas-ranking-card huas-card-bordered">
                          <div class="huas-card-head">
                            <div class="huas-card-head-wrapper">
                                <div class="huas-card-head-title">收益榜</div>
                                <div class="huas-card-extra">
                                  <div style="margin: 2px；" >
                                      <el-radio-group v-model="radioTable" size="small">
                                      <el-radio-button label="一周" ></el-radio-button>
                                      <el-radio-button label="一月"></el-radio-button>
                                      <el-radio-button label="一季"></el-radio-button>
                                      </el-radio-group>
                                  </div>
                              </div>
                            </div>
                          </div>
                          <div class="huas-card-body">
                            <div class="huas-table-wrapper">
                                <div class="huas-spin-nested-loading">
                                    <div class="huas-spin-container">
                                        <div class="huas-table huas-table-default huas-table-scroll-position-left">
                                            <div class="huas-table-content">
                                                <div class="huas-table-body">
<!--                                                     <el-table
                                                        :data="w1_strategiesList"

                                                        style="width: 100%">
                                                        <el-table-column
                                                            prop="RowNum"
                                                            label=""
                                                            width="39"
                                                           >
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="name"
                                                            label="策略名称"
                                                            width="156">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="策略近1周收益率"
                                                            label="近1周收益"
                                                            width="98">
                                                        </el-table-column>
                                                        </el-table> -->
                                                        <div v-if="radioTable==='一周'" style="display: block; justify-content: center">
                                                          <Table :columns="w1_strategiesColumns" :data="w1_strategiesList" width="310">
                                                            <template #RowNum="{ row }" >
                                                              <div class="column_center">
                                                                <span
                                                                  v-if="row.RowNum === 1"
                                                                  class="huas-ranking-card-rank_1"
                                                                  >{{ row.RowNum }}</span
                                                                >
                                                                <span
                                                                  v-else-if="row.RowNum === 2"
                                                                  class="huas-ranking-card-rank_2"
                                                                  >{{ row.RowNum }}</span
                                                                >        
                                                                <span
                                                                  v-else-if="row.RowNum === 3"
                                                                  class="huas-ranking-card-rank_3"
                                                                  >{{ row.RowNum }}</span
                                                                >                                                                                                                        
                                                                <span v-else class="huas-ranking-card-rank">{{ row.RowNum }}</span>
                                                              </div>
                                                            </template>  
                                                            <template #name="{ row }" >
                                                              <div class="column_center">
                                                                <router-link :to="{name:'strategydetailsview', query:{sid:row.sid,name:row.name, ben_name:row.ben_name}}" custom v-slot="{ navigate }">
                                                                    <div class="" @click="navigate" role="link">
                                                                      <span class="strategy-title">{{row.name}}  </span>
                                                                    </div>
                                                                </router-link>                                                     

                                                              </div>
                                                            </template>
                                                            <template #策略近1周收益率="{ row }" >
                                                              <div class="column_center">
                                                                <span v-if="row.策略近1周收益率>=0" class="demo-table-postive-column">{{row.策略近1周收益率}}  </span>
                                                                <span v-else="" class="demo-table-minus-column">{{row.策略近1周收益率}}  </span>

                                                              </div>
                                                            </template>
                                                                                                                                                                                          
                                                          </Table> 
                                                        </div>
                                                        <div v-else-if="radioTable==='一月'" style="display: block; justify-content: center">
                                                          <Table :columns="m1_strategiesColumns" :data="m1_strategiesList" width="310">
                                                            <template #RowNum="{ row }" >
                                                              <div class="column_center">
                                                                <span
                                                                  v-if="row.RowNum === 1"
                                                                  class="huas-ranking-card-rank_1"
                                                                  >{{ row.RowNum }}</span
                                                                >
                                                                <span
                                                                  v-else-if="row.RowNum === 2"
                                                                  class="huas-ranking-card-rank_2"
                                                                  >{{ row.RowNum }}</span
                                                                >        
                                                                <span
                                                                  v-else-if="row.RowNum === 3"
                                                                  class="huas-ranking-card-rank_3"
                                                                  >{{ row.RowNum }}</span
                                                                >                                                                                                                        
                                                                <span v-else class="huas-ranking-card-rank">{{ row.RowNum }}</span>
                                                              </div>
                                                            </template>  
                                                            <template #name="{ row }" >
                                                              <div class="column_center">
                                                                <router-link :to="{name:'strategydetailsview', query:{sid:row.sid,name:row.name, ben_name:row.ben_name}}" custom v-slot="{ navigate }">
                                                                    <div class="" @click="navigate" role="link">
                                                                      <span class="strategy-title">{{row.name}}  </span>
                                                                    </div>
                                                                </router-link>                                                     

                                                              </div>
                                                            </template>
                                                            <template #策略近1月收益率="{ row }" >
                                                              <div class="column_center">
                                                                <span v-if="row.策略近1月收益率>=0" class="demo-table-postive-column">{{row.策略近1月收益率}}  </span>
                                                                <span v-else="" class="demo-table-minus-column">{{row.策略近1月收益率}}  </span>

                                                              </div>
                                                            </template>
                                                                                                                                                                                          
                                                          </Table> 
                                                        </div>
                                                        <div v-else="" style="display: block; justify-content: center">
                                                          <Table :columns="m3_strategiesColumns" :data="m3_strategiesList" width="310">
                                                            <template #RowNum="{ row }" >
                                                              <div class="column_center">
                                                                <span
                                                                  v-if="row.RowNum === 1"
                                                                  class="huas-ranking-card-rank_1"
                                                                  >{{ row.RowNum }}</span
                                                                >
                                                                <span
                                                                  v-else-if="row.RowNum === 2"
                                                                  class="huas-ranking-card-rank_2"
                                                                  >{{ row.RowNum }}</span
                                                                >        
                                                                <span
                                                                  v-else-if="row.RowNum === 3"
                                                                  class="huas-ranking-card-rank_3"
                                                                  >{{ row.RowNum }}</span
                                                                >                                                                                                                        
                                                                <span v-else class="huas-ranking-card-rank">{{ row.RowNum }}</span>
                                                              </div>
                                                            </template>  
                                                            <template #name="{ row }" >
                                                              <div class="column_center">
                                                                <router-link :to="{name:'strategydetailsview', query:{sid:row.sid,name:row.name, ben_name:row.ben_name}}" custom v-slot="{ navigate }">
                                                                    <div class="" @click="navigate" role="link">
                                                                      <span class="strategy-title">{{row.name}}  </span>
                                                                    </div>
                                                                </router-link>                                                     

                                                              </div>
                                                            </template>
                                                            <template #策略近3月收益率="{ row }" >
                                                              <div class="column_center">
                                                                <span v-if="row.策略近3月收益率>=0" class="demo-table-postive-column">{{row.策略近3月收益率}}  </span>
                                                                <span v-else="" class="demo-table-minus-column">{{row.策略近3月收益率}}  </span>

                                                              </div>
                                                            </template>
                                                                                                                                                                                          
                                                          </Table> 
                                                        </div>                                                                                                                                                                          
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="huas-card huas-ranking-card huas-card-bordered">
                          <div class="huas-card-head">
                            <div class="huas-card-head-wrapper">
                                <div class="huas-card-head-title">胜率榜</div>
                            </div>
                          </div>
                          <div class="huas-card-body">
                            <div class="huas-table-wrapper">
                                <div class="huas-spin-nested-loading">
                                    <div class="huas-spin-container">
                                        <div class="huas-table huas-table-default huas-table-scroll-position-left">
                                            <div class="huas-table-content">
                                                <div class="huas-table-body">
<!--                                                     <el-table
                                                        :data="win_strategiesList"

                                                        style="width: 100%">
                                                        <el-table-column
                                                            prop="RowNum"
                                                            label=""
                                                            width="39">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="name"
                                                            label="策略名称"
                                                            width="156">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="胜率"
                                                            label="胜率"
                                                            width="98">
                                                        </el-table-column>
                                                        </el-table> -->
                                                        <Table :columns="win_strategiesColumns" :data="win_strategiesList" width="310">
                                                            <template #RowNum="{ row }" >
                                                              <div class="column_center">
                                                                <span
                                                                  v-if="row.RowNum === 1"
                                                                  class="huas-ranking-card-rank_1"
                                                                  >{{ row.RowNum }}</span
                                                                >
                                                                <span
                                                                  v-else-if="row.RowNum === 2"
                                                                  class="huas-ranking-card-rank_2"
                                                                  >{{ row.RowNum }}</span
                                                                >        
                                                                <span
                                                                  v-else-if="row.RowNum === 3"
                                                                  class="huas-ranking-card-rank_3"
                                                                  >{{ row.RowNum }}</span
                                                                >                                                                                                                        
                                                                <span v-else class="huas-ranking-card-rank">{{ row.RowNum }}</span>
                                                              </div>
                                                            </template>  
                                                            <template #name="{ row }" >
                                                              <div class="column_center">
                                                                <router-link :to="{name:'strategydetailsview', query:{sid:row.sid,name:row.name, ben_name:row.ben_name}}" custom v-slot="{ navigate }">
                                                                    <div class="" @click="navigate" role="link">
                                                                      <span class="strategy-title">{{row.name}}  </span>
                                                                    </div>
                                                                </router-link>                                                     

                                                              </div>
                                                            </template>
                                                            <template #胜率="{ row }" >
                                                              <div class="column_center">
                                                                <span  class="demo-table-number-column">{{row.胜率}}  </span>

                                                              </div>
                                                            </template>
                                                                                                                                                                                          
                                                          </Table>                                                         
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div> 
                        <div class="huas-card huas-ranking-card huas-card-bordered">
                          <div class="huas-card-head">
                            <div class="huas-card-head-wrapper">
                                <div class="huas-card-head-title">今日收益排名</div>
                            </div>
                          </div>
                          <div class="huas-card-body">
                            <div class="huas-table-wrapper">
                                <div class="huas-spin-nested-loading">
                                    <div class="huas-spin-container">
                                        <div class="huas-table huas-table-default huas-table-scroll-position-left">
                                            <div class="huas-table-content">
                                                <div class="huas-table-body">
<!--                                                     <el-table
                                                        :data="hot_strategiesList"
                                                        :cell-class-name="rowClass"
                                                        style="width: 100%">
                                                        <el-table-column
                                                            prop="RowNum"
                                                            label=""
                                                            width="39">
                                                     <template #scope="{row}">
                                                            <span v-if="row.RowNum == 1" data-rank='1' class="huas-ranking-card-rank_1">{{ row.RowNum+10 }}</span>
                                                            <span v-else-if="row.RowNum == 2" data-rank='2' class="huas-ranking-card-rank_2">{{ row.RowNum+20 }}</span>
                                                            <span v-else-if="row.RowNum == 3" data-rank='3' class="huas-ranking-card-rank_3">{{ row.RowNum+30 }}</span>
                                                            <span v-else=""  class="huas-ranking-card-rank_1">{{ row.RowNum+40 }}</span>
                                                        </template>    
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="name"
                                                            label="策略名称"
                                                            width="156">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="策略近1周收益率"
                                                            label="近1周收益"
                                                            width="98">
                                                        </el-table-column>
                                                        </el-table> -->
                                                        <Table :columns="d1_strategiesColumns" :data="d1_strategiesList" width="310">
                                                          <template #RowNum="{ row }" >
                                                            <div class="column_center">
                                                              <span
                                                                v-if="row.RowNum === 1"
                                                                class="huas-ranking-card-rank_1"
                                                                >{{ row.RowNum }}</span
                                                              >
                                                              <span
                                                                v-else-if="row.RowNum === 2"
                                                                class="huas-ranking-card-rank_2"
                                                                >{{ row.RowNum }}</span
                                                              >        
                                                              <span
                                                                v-else-if="row.RowNum === 3"
                                                                class="huas-ranking-card-rank_3"
                                                                >{{ row.RowNum }}</span
                                                              >                                                                                                                        
                                                              <span v-else class="huas-ranking-card-rank">{{ row.RowNum }}</span>
                                                            </div>
                                                          </template>  
                                                          <template #name="{ row }" >
                                                            <div class="column_center">
                                                              <router-link :to="{name:'strategydetailsview', query:{sid:row.sid,name:row.name, ben_name:row.ben_name}}" custom v-slot="{ navigate }">
                                                                  <div class="" @click="navigate" role="link">
                                                                    <span class="strategy-title">{{row.name}}  </span>
                                                                  </div>
                                                              </router-link>                                                     

                                                            </div>
                                                          </template>
                                                          <template #策略当日收益率="{ row }" >
                                                            <div class="column_center">
                                                              <span v-if="row.策略当日收益率>=0" class="demo-table-postive-column">{{row.策略当日收益率}}  </span>
                                                              <span v-else="" class="demo-table-minus-column">{{row.策略当日收益率}}  </span>

                                                            </div>
                                                          </template>
                                                                                                                                                                                        
                                                        </Table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>                                               
</template>

<script setup>
import { toRefs,reactive, onMounted } from 'vue'
import API from "@/api/axiosInstance"

    let data = reactive({}); 
    let hot_strategiesList = reactive([]);
    let w1_strategiesList = reactive([]);
    let d1_strategiesList = reactive([]);
    let m1_strategiesList = reactive([]);
    let m3_strategiesList = reactive([]);
    let win_strategiesList = reactive([]);
    

    const  hotstrategiesColumns = [
        {
          title: " ",
          slot: "RowNum",
          //key: "RowNum",
          width: 39,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "策略名称",
          slot: "name",
          //key: "name",
          width: 156,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "近1周收益",
          slot: "策略近1周收益率",
          //key: "策略近1周收益率",
          width: 98,
          align: "center",
          className: 'table-head-style',
        }
      ];

      const  w1_strategiesColumns = [
        {
          title: " ",
          slot: "RowNum",
          //key: "RowNum",
          width: 39,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "策略名称",
          slot: "name",
          //key: "name",
          width: 156,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "近1周收益",
          slot: "策略近1周收益率",
          //key: "策略近1周收益率",
          width: 98,
          align: "center",
          className: 'table-head-style',
        }
      ];    
 
      const  d1_strategiesColumns = [
        {
          title: " ",
          slot: "RowNum",
          //key: "RowNum",
          width: 39,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "策略名称",
          slot: "name",
          //key: "name",
          width: 156,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "当日收益",
          slot: "策略当日收益率",
          //key: "策略当日收益率",
          width: 98,
          align: "center",
          className: 'table-head-style',
        }
      ];        
      const  m1_strategiesColumns = [
        {
          title: " ",
          slot: "RowNum",
          //key: "RowNum",
          width: 39,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "策略名称",
          slot: "name",
          //key: "name",
          width: 156,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "近1月收益",
          slot: "策略近1月收益率",
          //key: "策略近1月收益率",
          width: 98,
          align: "center",
          className: 'table-head-style',
        }
      ];   

      const  m3_strategiesColumns = [
        {
          title: " ",
          slot: "RowNum",
          //key: "RowNum",
          width: 39,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "策略名称",
          slot: "name",
          //key: "name",
          width: 156,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "近1季收益",
          slot: "策略近3月收益率",
          //key: "策略近3月收益率",
          width: 98,
          align: "center",
          className: 'table-head-style',
        }
      ];     
      
      const  win_strategiesColumns = [
        {
          title: " ",
          slot: "RowNum",
          //key: "RowNum",
          width: 39,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "策略名称",
          slot: "name",
          //key: "name",
          width: 156,
          align: "center",
          className: 'table-head-style',
        },
        {
          title: "胜率",
          slot: "胜率",
          //key: "胜率",
          width: 98,
          align: "center",
          className: 'table-head-style',
        }
      ];    

    function getData(){
          let moment = require('moment');
          // get data from server
          API({
              url:'/ios.ashx?typedata=sidebardata',
              method:'get'
          }).then((res)=>{
            // mapping the server data
            data = res.data;
            //console.log(res.data);
            // TODO: extracting board info?
  
            // clear the strategy list
            hot_strategiesList.splice(0, hot_strategiesList.length);
            d1_strategiesList.splice(0, d1_strategiesList.length);
            w1_strategiesList.splice(0, w1_strategiesList.length);
            m1_strategiesList.splice(0, m1_strategiesList.length);
            m3_strategiesList.splice(0, m3_strategiesList.length);
            win_strategiesList.splice(0, win_strategiesList.length);
            
            if(data.hot策略榜 && Array.isArray(data.hot策略榜)){
            data.hot策略榜.forEach(function(item) {
              // set up a variable for storing all info for a strategy
              let strategy = {
                name: "",
                author: "",
                ben_name:"",
                realTradingDays: "",
                realTradingReturns: "",
                stPrice: "",
                fundingCap: "",
                RowNum:0,
                data: [{
                  date: "",
                  value: "",
                  bench_value: ""
                }]
              };
  
              // mapping description of the strategy
              strategy.name = item.策略名称;
              strategy.ben_name = item.基准名称;
              strategy.author = item.策略作者;
              strategy.realTradingDays = item.实盘天数;
              strategy.realTradingReturns = item.策略累计收益率.toFixed(2);
              strategy.stPrice = item.策略定价;
              strategy.fundingCap = item.资金上限;
              strategy.RowNum = item.RowNum;
              strategy.sid = item.sid;
              strategy.策略累计收益率 = item.策略累计收益率.toFixed(2);
              strategy.策略年化收益率 = item.策略年化收益率.toFixed(2);
              strategy.策略特性 = item.策略特性;
              strategy.作者描述 = item.作者描述;
              strategy.净值涨跌幅 = item.净值涨跌幅;
              strategy.策略定价 = item.策略定价;
              strategy.资金上限 = item.资金上限;
              strategy.初始资金 = item.初始资金;
              strategy.实盘分数 = item.实盘分数;
              strategy.策略当日收益率 = item.策略当日收益率.toFixed(2);
              strategy.策略近1周收益率 = item.策略近1周收益率.toFixed(2);
              strategy.策略近1月收益率 = item.策略近1月收益率.toFixed(2);
              strategy.策略近3月收益率 = item.策略近3月收益率.toFixed(2);
              strategy.策略近6月收益率 = item.策略近6月收益率.toFixed(2);
              strategy.策略近1年收益率 = item.策略近1年收益率.toFixed(2);
              strategy.策略最大回撤率 = item.策略最大回撤率.toFixed(2);
              strategy.胜率 = item.胜率.toFixed(2);
              strategy.夏普比率 = item.夏普比率;
              var n=item.创建日期.split("T");
              strategy.开始时间 = n[0];
              
              //console.log('strategy.开始时间=',strategy.开始时间);
              // adjusting data for echart 
              // turning list of objects into three corresponding arrays
              strategy.data.length = 0;
              item.data.forEach(function(strat) {
                strategy.data.push({
                  date:moment(strat.utc).format('YYYY/MM/DD'),//strat.utc,
                  value: Number(strat.vpct),   
                  bench_value: Number(strat.b_vpct),
                })
              })
              
              // adding the strategy back to the list
              hot_strategiesList.push(strategy);
            })
          }

            data.收益榜1周.forEach(function(item) {
              // set up a variable for storing all info for a strategy
              let strategy = {
                name: "",
                author: "",
                ben_name:"",
                realTradingDays: "",
                realTradingReturns: "",
                stPrice: "",
                fundingCap: "",
                RowNum:0,
                data: [{
                  date: "",
                  value: "",
                  bench_value: ""
                }]
              };
  
              // mapping description of the strategy
              strategy.name = item.策略名称;
              strategy.ben_name = item.基准名称;
              strategy.author = item.策略作者;
              strategy.realTradingDays = item.实盘天数;
              strategy.realTradingReturns = item.策略累计收益率.toFixed(2);
              strategy.stPrice = item.策略定价;
              strategy.fundingCap = item.资金上限;
              strategy.RowNum = item.RowNum;
              strategy.sid = item.sid;
              strategy.策略累计收益率 = item.策略累计收益率.toFixed(2);
              strategy.策略年化收益率 = item.策略年化收益率.toFixed(2);
              strategy.策略特性 = item.策略特性;
              strategy.作者描述 = item.作者描述;
              strategy.净值涨跌幅 = item.净值涨跌幅;
              strategy.策略定价 = item.策略定价;
              strategy.资金上限 = item.资金上限;
              strategy.初始资金 = item.初始资金;
              strategy.实盘分数 = item.实盘分数;
              strategy.策略当日收益率 = item.策略当日收益率.toFixed(2);
              strategy.策略近1周收益率 = item.策略近1周收益率.toFixed(2);
              strategy.策略近1月收益率 = item.策略近1月收益率.toFixed(2);
              strategy.策略近3月收益率 = item.策略近3月收益率.toFixed(2);
              strategy.策略近6月收益率 = item.策略近6月收益率.toFixed(2);
              strategy.策略近1年收益率 = item.策略近1年收益率.toFixed(2);
              strategy.策略最大回撤率 = item.策略最大回撤率.toFixed(2);
              strategy.胜率 = item.胜率.toFixed(2);
              strategy.夏普比率 = item.夏普比率;
              var n=item.创建日期.split("T");
              strategy.开始时间 = n[0];
              
              //console.log('strategy.开始时间=',strategy.开始时间);
              // adjusting data for echart 
              // turning list of objects into three corresponding arrays
              strategy.data.length = 0;
              item.data.forEach(function(strat) {
                strategy.data.push({
                  date:moment(strat.utc).format('YYYY/MM/DD'),//strat.utc,
                  value: Number(strat.vpct),   
                  bench_value: Number(strat.b_vpct),
                })
              })
              
              // adding the strategy back to the list
              w1_strategiesList.push(strategy);
            })
          
            data.收益榜今天.forEach(function(item) {
              // set up a variable for storing all info for a strategy
              let strategy = {
                name: "",
                author: "",
                ben_name:"",
                realTradingDays: "",
                realTradingReturns: "",
                stPrice: "",
                fundingCap: "",
                RowNum:0,
                data: [{
                  date: "",
                  value: "",
                  bench_value: ""
                }]
              };
  
              // mapping description of the strategy
              strategy.name = item.策略名称;
              strategy.ben_name = item.基准名称;
              strategy.author = item.策略作者;
              strategy.realTradingDays = item.实盘天数;
              strategy.realTradingReturns = item.策略累计收益率.toFixed(2);
              strategy.stPrice = item.策略定价;
              strategy.fundingCap = item.资金上限;
              strategy.RowNum = item.RowNum;
              strategy.sid = item.sid;
              strategy.策略累计收益率 = item.策略累计收益率.toFixed(2);
              strategy.策略年化收益率 = item.策略年化收益率.toFixed(2);
              strategy.策略特性 = item.策略特性;
              strategy.作者描述 = item.作者描述;
              strategy.净值涨跌幅 = item.净值涨跌幅;
              strategy.策略定价 = item.策略定价;
              strategy.资金上限 = item.资金上限;
              strategy.初始资金 = item.初始资金;
              strategy.实盘分数 = item.实盘分数;
              strategy.策略当日收益率 = item.策略当日收益率.toFixed(2);
              strategy.策略近1周收益率 = item.策略近1周收益率.toFixed(2);
              strategy.策略近1月收益率 = item.策略近1月收益率.toFixed(2);
              strategy.策略近3月收益率 = item.策略近3月收益率.toFixed(2);
              strategy.策略近6月收益率 = item.策略近6月收益率.toFixed(2);
              strategy.策略近1年收益率 = item.策略近1年收益率.toFixed(2);
              strategy.策略最大回撤率 = item.策略最大回撤率.toFixed(2);
              strategy.胜率 = item.胜率.toFixed(2);
              strategy.夏普比率 = item.夏普比率;
              var n=item.创建日期.split("T");
              strategy.开始时间 = n[0];
              
              //console.log('strategy.开始时间=',strategy.开始时间);
              // adjusting data for echart 
              // turning list of objects into three corresponding arrays
              strategy.data.length = 0;
              item.data.forEach(function(strat) {
                strategy.data.push({
                  date:moment(strat.utc).format('YYYY/MM/DD'),//strat.utc,
                  value: Number(strat.vpct),   
                  bench_value: Number(strat.b_vpct),
                })
              })
              
              // adding the strategy back to the list
              d1_strategiesList.push(strategy);
            })
            data.收益榜1月.forEach(function(item) {
              // set up a variable for storing all info for a strategy
              let strategy = {
                name: "",
                author: "",
                ben_name:"",
                realTradingDays: "",
                realTradingReturns: "",
                stPrice: "",
                fundingCap: "",
                RowNum:0,
                data: [{
                  date: "",
                  value: "",
                  bench_value: ""
                }]
              };
  
              // mapping description of the strategy
              strategy.name = item.策略名称;
              strategy.ben_name = item.基准名称;
              strategy.author = item.策略作者;
              strategy.realTradingDays = item.实盘天数;
              strategy.realTradingReturns = item.策略累计收益率.toFixed(2);
              strategy.stPrice = item.策略定价;
              strategy.fundingCap = item.资金上限;
              strategy.RowNum = item.RowNum;
              strategy.sid = item.sid;
              strategy.策略累计收益率 = item.策略累计收益率.toFixed(2);
              strategy.策略年化收益率 = item.策略年化收益率.toFixed(2);
              strategy.策略特性 = item.策略特性;
              strategy.作者描述 = item.作者描述;
              strategy.净值涨跌幅 = item.净值涨跌幅;
              strategy.策略定价 = item.策略定价;
              strategy.资金上限 = item.资金上限;
              strategy.初始资金 = item.初始资金;
              strategy.实盘分数 = item.实盘分数;
              strategy.策略当日收益率 = item.策略当日收益率.toFixed(2);
              strategy.策略近1周收益率 = item.策略近1周收益率.toFixed(2);
              strategy.策略近1月收益率 = item.策略近1月收益率.toFixed(2);
              strategy.策略近3月收益率 = item.策略近3月收益率.toFixed(2);
              strategy.策略近6月收益率 = item.策略近6月收益率.toFixed(2);
              strategy.策略近1年收益率 = item.策略近1年收益率.toFixed(2);
              strategy.策略最大回撤率 = item.策略最大回撤率.toFixed(2);
              strategy.胜率 = item.胜率.toFixed(2);
              strategy.夏普比率 = item.夏普比率;
              var n=item.创建日期.split("T");
              strategy.开始时间 = n[0];
              
              //console.log('strategy.开始时间=',strategy.开始时间);
              // adjusting data for echart 
              // turning list of objects into three corresponding arrays
              strategy.data.length = 0;
              item.data.forEach(function(strat) {
                strategy.data.push({
                  date:moment(strat.utc).format('YYYY/MM/DD'),//strat.utc,
                  value: Number(strat.vpct),   
                  bench_value: Number(strat.b_vpct),
                })
              })
              
              // adding the strategy back to the list
              m1_strategiesList.push(strategy);
            })
            data.收益榜3月.forEach(function(item) {
              // set up a variable for storing all info for a strategy
              let strategy = {
                name: "",
                author: "",
                ben_name:"",
                realTradingDays: "",
                realTradingReturns: "",
                stPrice: "",
                fundingCap: "",
                RowNum:0,
                data: [{
                  date: "",
                  value: "",
                  bench_value: ""
                }]
              };
  
              // mapping description of the strategy
              strategy.name = item.策略名称;
              strategy.ben_name = item.基准名称;
              strategy.author = item.策略作者;
              strategy.realTradingDays = item.实盘天数;
              strategy.realTradingReturns = item.策略累计收益率.toFixed(2);
              strategy.stPrice = item.策略定价;
              strategy.fundingCap = item.资金上限;
              strategy.RowNum = item.RowNum;
              strategy.sid = item.sid;
              strategy.策略累计收益率 = item.策略累计收益率.toFixed(2);
              strategy.策略年化收益率 = item.策略年化收益率.toFixed(2);
              strategy.策略特性 = item.策略特性;
              strategy.作者描述 = item.作者描述;
              strategy.净值涨跌幅 = item.净值涨跌幅;
              strategy.策略定价 = item.策略定价;
              strategy.资金上限 = item.资金上限;
              strategy.初始资金 = item.初始资金;
              strategy.实盘分数 = item.实盘分数;
              strategy.策略当日收益率 = item.策略当日收益率.toFixed(2);
              strategy.策略近1周收益率 = item.策略近1周收益率.toFixed(2);
              strategy.策略近1月收益率 = item.策略近1月收益率.toFixed(2);
              strategy.策略近3月收益率 = item.策略近3月收益率.toFixed(2);
              strategy.策略近6月收益率 = item.策略近6月收益率.toFixed(2);
              strategy.策略近1年收益率 = item.策略近1年收益率.toFixed(2);
              strategy.策略最大回撤率 = item.策略最大回撤率.toFixed(2);
              strategy.胜率 = item.胜率.toFixed(2);
              strategy.夏普比率 = item.夏普比率;
              var n=item.创建日期.split("T");
              strategy.开始时间 = n[0];
              
              //console.log('strategy.开始时间=',strategy.开始时间);
              // adjusting data for echart 
              // turning list of objects into three corresponding arrays
              strategy.data.length = 0;
              item.data.forEach(function(strat) {
                strategy.data.push({
                  date:moment(strat.utc).format('YYYY/MM/DD'),//strat.utc,
                  value: Number(strat.vpct),   
                  bench_value: Number(strat.b_vpct),
                })
              })
              
              // adding the strategy back to the list
              m3_strategiesList.push(strategy);
            })
            data.胜率榜.forEach(function(item) {
              // set up a variable for storing all info for a strategy
              let strategy = {
                name: "",
                author: "",
                ben_name:"",
                realTradingDays: "",
                realTradingReturns: "",
                stPrice: "",
                fundingCap: "",
                RowNum:0,
                data: [{
                  date: "",
                  value: "",
                  bench_value: ""
                }]
              };
  
              // mapping description of the strategy
              strategy.name = item.策略名称;
              strategy.ben_name = item.基准名称;
              strategy.author = item.策略作者;
              strategy.realTradingDays = item.实盘天数;
              strategy.realTradingReturns = item.策略累计收益率.toFixed(2);
              strategy.stPrice = item.策略定价;
              strategy.fundingCap = item.资金上限;
              strategy.RowNum = item.RowNum;
              strategy.sid = item.sid;
              strategy.策略累计收益率 = item.策略累计收益率.toFixed(2);
              strategy.策略年化收益率 = item.策略年化收益率.toFixed(2);
              strategy.策略特性 = item.策略特性;
              strategy.作者描述 = item.作者描述;
              strategy.净值涨跌幅 = item.净值涨跌幅;
              strategy.策略定价 = item.策略定价;
              strategy.资金上限 = item.资金上限;
              strategy.初始资金 = item.初始资金;
              strategy.实盘分数 = item.实盘分数;
              strategy.策略当日收益率 = item.策略当日收益率.toFixed(2);
              strategy.策略近1周收益率 = item.策略近1周收益率.toFixed(2);
              strategy.策略近1月收益率 = item.策略近1月收益率.toFixed(2);
              strategy.策略近3月收益率 = item.策略近3月收益率.toFixed(2);
              strategy.策略近6月收益率 = item.策略近6月收益率.toFixed(2);
              strategy.策略近1年收益率 = item.策略近1年收益率.toFixed(2);
              strategy.策略最大回撤率 = item.策略最大回撤率.toFixed(2);
              strategy.胜率 = item.胜率.toFixed(2);
              strategy.夏普比率 = item.夏普比率;
              var n=item.创建日期.split("T");
              strategy.开始时间 = n[0];
              
              //console.log('strategy.开始时间=',strategy.开始时间);
              // adjusting data for echart 
              // turning list of objects into three corresponding arrays
              strategy.data.length = 0;
              item.data.forEach(function(strat) {
                strategy.data.push({
                  date:moment(strat.utc).format('YYYY/MM/DD'),//strat.utc,
                  value: Number(strat.vpct),   
                  bench_value: Number(strat.b_vpct),
                })
              })
              
              // adding the strategy back to the list
              win_strategiesList.push(strategy);
            })
          });
        }
    function cellStyle(row,column,rowIndex,columnIndex){//根据报警级别显示颜色
        // console.log(row);
        // console.log(row.column);
        if(row.row.RowNum===1){
          return 'color: #e7493b;'
        }else if(row.row.RowNum===2 ){
          return 'color: #ff7f00;'
        }else if(row.row.RowNum===3 ){
          return 'color: #eca400;'
        }
        else{
          return 'color: #bfc5c8;'
        }
      }
    function rowClass({row, column, rowIndex, columnIndex}) {
        if(row.RowNum !== null) {
            //for (let i = 0; i < row.columnList.length; i++) {
              //console.log(rowIndex, columnIndex,row.RowNum);
              if(columnIndex===0){
                if (rowIndex===0) {
                    //console.log(row.RowNum);
                    return 'huas-ranking-card-rank_1';
                }
                else if (rowIndex===1) {
                    return 'huas-ranking-card-rank_2';
                }
                else if (rowIndex===2) {
                    return 'huas-ranking-card-rank_3';
                }
                else {
                  
                    return 'huas-ranking-card-rank';
                }
            }
        }
    }
      //getData();

        onMounted(() => {

            getData();
            });

        //return{hot_strategiesList,w1_strategiesList,m1_strategiesList,m3_strategiesList,win_strategiesList,cellStyle};
    


</script>
<script>
 export default {
        data () {
            return {
              radioTable:'一周',
            }
        }
    }
</script>
<style scoped>

.huas-card {
  --main-bg-color: coral;
  --main-txt-color: blue;
  --main-padding: 15px;
  --white-color: #fff;
  --huas-color-red-0: #ec2000;
  --huas-color-red-1: #e74c3c;
  --huas-color-orange-0: #ec8950;
  --huas-color-blue-0: #1890ff;
  --huas-color-blue-1: #1099ff;
  --huas-font-color-0: #555;
  --huas-font-color-1: #888;
  --huas-page-bg-color: #f7f7f7;
  --huas-border-radius: 2px;
  --huas-border-color: #f6f6f6;
  --huas-border-color-dark: #d9d9d9;
  --huas-font-size-base: 14px;
  --huas-font-size-title: 22px;
  --huas-font-color-base: var(--huas-font-color-0);
  --huas-font-color-light: var(--huas-font-color-1);
  --huas-card-broder-color:  #f6f6f6;
  --huas-card-broder-radius: 0;
  --huas-card-bg-color: #fff;
}

.huas-ranking-card{
  color: var(--huas-font-color-base);
  background: var(--huas-card-bg-color);
  position: relative;

}

.huas-card-bordered {
  border: 1px solid var(--huas-card-broder-color);
    border-radius: 2px;
}


.huas-ranking-card > .huas-card-head:before {
  content: ' ';
  position: absolute;
  width: 4px;
  height: 18px;
  background: var(--huas-color-red-0);
  left: 0px;
  top: 15px;
}
.huas-card-head{
    min-height: 48px;
    padding-left: 24px;
    padding-right: 16px;
    zoom: 1;
    border-bottom: 1px solid var(--huas-card-broder-color); 
}

.huas-main-sidebar .huas-card:not(:first-child) {
    margin-top: 20px;
  }
  
  .huas-card-title {
    display: flex;
    align-items: center;
  }
  
  .huas-card-title-icon {
    font-size: 14px;
    cursor: pointer;
    color: #999;
    height: 20px;
    margin-left: 2px;
  }
  
  .huas-ranking-card {
    color: var(--huas-font-color-base);
    position: relative;
  }
  
  .huas-ranking-card > .huas-card-head:before {
    content: ' ';
    position: absolute;
    width: 4px;
    height: 18px;
    background: var(--huas-color-red-0);
    left: 0px;
    top: 15px;
  }
  
  .huas-ranking-card:last-child {
    position: sticky;
    top: 62px;
  }
  
  .huas-ranking-card .huas-icon-info {
    color: #999;
    height: 16px;
    margin-left: 2px;
    position: relative;
    top: 2px;
  }
  
  .huas-ranking-card .huas-empty {
    margin: 56px auto;
  }
  
  .huas-ranking-card .huas-table {
    padding: 13px 20px 15px 0;
  }
  
  .huas-ranking-card .FormatterNumber {
    font-weight: 500;
    font-size: 16px;
  }
  
  .huas-ranking-card .huas-table-thead th {
    height: 22px;
  }
  
  .huas-ranking-card .huas-table-row {
    height: 42px;
  }
  
  .huas-ranking-card .huas-ranking-card-algoName {
    color: #555;
  }
  
 .huas-ranking-card-rank {
    font-weight: 600;
    font-size: 18px;
    color: #bfc5c8;
  }
    .huas-ranking-card-rank_1 {
    color: #e7493b;
    font-weight: 600;
    font-size: 18px;
  }
  
  .huas-ranking-card-rank_2 {
    color: #ff7f00;
    font-weight: 600;
    font-size: 18px;
  }
  
  .huas-ranking-card-rank_3 {
    color: #eca400;
    font-weight: 600;
    font-size: 18px;
  }
  
  .huas-ranking-card .huas-table-row > td:nth-child(1) {
    width: 44px;
  }
  
  .huas-ranking-card .huas-table-row > td:nth-child(2) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 0;
  }
  
  .more-tips {
    text-align: center;
    line-height: 2;
    color: #8a8a8a;
    width: 45.2em;
    margin: 50px auto 60px;
  }
  .more-tips .risk-tip {
    font-size: 14px;
    line-height: 19px;
  }
  .more-tips .lookforward-tip {
    font-weight: normal;
    color: #96948e;
    font-size: 16px;
    line-height: 21px;
    margin-top: 15px;
  }
  .more-tips .link-tip {
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    margin-top: 23px;
    width: 240px;
  }
  .more-tips .link-tip a {
    color: #e74c3c;
    line-height: 16px;
    font-size: 14px;
  }
  
  .huas-btn-vip {
    padding: 0 20px;
  }
  
.huas-card-body{
    margin: 0;
    padding: 0;
}
.huas-table-wrapper{
    margin: 0;
    padding: 0;
}

.huas-table {
  --huas-table-title-color: #999;
  padding: 13px 20px 15px 0;
}
.huas-table-content{
  margin: 0;
    padding: 0;
}
.huas-table-body{
  margin: 0;
    padding: 0;
}

.huas-table .huas-table-thead th {
  font-weight: normal;
  color: var(--huas-table-title-color);
}
.huas-spin-nested-loading{
    position: relative;
}
.huas-spin-container{
    position: relative;
    transition: opacity .3s;
}
.ant-card-head {
    margin-bottom: -1px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 16px;
    background: transparent;
    border-bottom: 1px solid #e8e8e8;
    border-radius: var(--huas-card-broder-radius) var(--huas-card-broder-radius) 0 0;
    zoom: 1;
  }
.huas-card-head-wrapper{
    display: flex;
    align-items: center;
}
.huas-card-head-title{
    font-weight: 500;
    font-size: 16px;
    color: #333;
    display: inline-block;
    flex: 1;
    padding: 10px 20px;
    line-height: 24px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
}
.column_center {
  text-align: center;
}
.demo-table-postive-column {
  color: rgb(248, 2, 2);
  text-align: center;
}
.demo-table-minus-column {
  color: rgb(10, 187, 60);
  text-align: center;
}

.demo-table-number-column {
  color: rgb(10, 10, 10);
  text-align: center;
}

.table-head-style{
    background-color: white;
  }
.huas-card-extra{
    color: #555;
    position: relative;
}

</style>